function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisappointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M254.5,81.631c-97.271,0-176.125,78.854-176.125,176.125c0,68.89,39.552,128.542,97.186,157.487 l155.169,1.331c59.1-28.418,99.895-88.854,99.895-158.818C430.625,160.485,351.771,81.631,254.5,81.631z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f3475d"
    },
    points: "123.941,224.132 57.941,338.448 189.941,338.448  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.409,
    y: 69.007,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 182.4014 448.2996)",
    style: {
      fill: "#FBF75F"
    },
    width: 127.883,
    height: 127.883
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5F7EFB"
    },
    cx: 384.879,
    cy: 302.146,
    r: 62.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5F7EFB"
    },
    points: "166.064,166.679 156.564,183.133 175.564,183.133  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBF75F"
    },
    points: "422.586,141.176 432.086,124.722 413.086,124.722  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f3475d"
    },
    points: "410.518,394.882 420.018,378.428 401.018,378.428  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3475d"
    },
    d: "M391.125,227.212c-0.3,0-0.605-0.007-0.918-0.021l0.281-5.994c6.336,0.298,8.311-4.14,8.517-4.648 l5.604,2.145C404.475,219.051,401.286,227.212,391.125,227.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBF75F"
    },
    d: "M78.962,388.405l-1.374-5.84c6.17-1.451,6.857-6.263,6.915-6.807l5.977,0.525 C90.448,376.676,89.572,385.91,78.962,388.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5F7EFB"
    },
    d: "M337.127,105.147c-0.226-0.321-5.458-7.979,1.101-16.685l4.791,3.611 c-3.814,5.061-1.266,9.199-0.962,9.654L337.127,105.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3475d"
    },
    d: "M78.921,144.087l-4.857-3.522c0.229-0.32,5.727-7.791,16.11-4.479l-1.823,5.717 C82.31,139.875,79.249,143.651,78.921,144.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBF75F"
    },
    d: "M224.049,126.371c-0.393-0.009-9.663-0.336-12.782-10.78l5.749-1.717 c1.814,6.073,6.657,6.475,7.203,6.5L224.049,126.371z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5F7EFB"
    },
    points: "217,423.799 345.867,423.799 334.174,360.235 191.761,364.941  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M262.629,374.002c0.68,6.944,1.361,13.887,2.041,20.831c3.176,0.588,6.447,1.167,9.624,1.755 c0.88-7.889,0.892-16.149,1.773-24.038"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M322.379,373.275c2.91,13.054,10.516,25.008,21.107,33.175"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#936149"
    },
    points: "219.471,423.799 217.235,409.823 151.941,416.811 152.647,423.799  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "214.059,378.882 221.647,409.823 147.697,418.172 142.138,399.288  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBF75F"
    },
    d: "M225.468,213.154c0,0-8.615,4.233-23.6,12.128c-14.985,7.895-24.307,16.291-37.882,36.446 c-13.574,20.155-24.579,50.772-27.547,78.993c-2.968,28.221,2.413,57.369,9.134,75.854l79.895-24.6l-5.91-15.865h134.284 l-12.68-60.381c23.367-11.022,25.223-30.434,13.825-56.728c-11.399-26.294-21.987-40.221-44.575-45.846 c-22.588-5.624-67.655-6.291-67.655-6.291L225.468,213.154z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "260.166,214.977 277.592,251.173 299.314,214.977  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "221.623,212.353 239.566,248.366 261.581,214.977 239.566,204.068  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M340.178,251.228l-45.104,17.864c-6.812,13.234-4.535,30.587,5.461,41.616 c9.996,11.029,27.041,14.997,40.88,9.516c13.839-5.481,23.545-20.043,23.278-34.926 C364.427,270.415,354.205,256.21,340.178,251.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M206.296,224.211l-7.006,90.555c7.141,21.384,14.281,42.769,21.422,64.153l-77.044,25.565"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 214.801,
    y1: 361.22,
    x2: 347.867,
    y2: 360.235
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M319.807,216.587c-0.352,5.647-0.705,11.294-1.057,16.941"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M146.247,300.421c5.863,8.467,8.447,19.144,7.104,29.355c-1.343,10.211-6.601,19.857-14.454,26.519"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3475d"
    },
    d: "M293.139,160.382c-0.629-2.786-2.765-5.074-5.587-5.518c1.132-4.063-0.91-8.782-4.647-10.738 c-3.736-1.957-8.439-1.375-11.134,1.869c-13.449-5.497-29.97-2.465-40.591,7.449s-14.782,26.187-10.224,39.982 c7.46,1.419,15.273,2.506,22.732,3.925l46.497-29.46C292.544,166.279,293.767,163.167,293.139,160.382z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#936149"
    },
    d: "M267.047,219.926c5.244-0.333,10.318-2.831,13.781-6.783c3.463-3.952,4.79-9.125,4.955-14.377 c0.354-11.247-1.97-22.327-6.896-32.443c-3.754,0.508-7.819-0.176-10.779-2.54c-7.646,1.947-14.735,3.758-22.381,5.705 c-0.88,1.119-2.671,2.275-2.909,3.679c-0.62,3.652-0.942,7.771-2.09,11.293c-0.487,1.493-2.092,2.489-3.649,2.291 c-1.01-1.227-1.852-2.687-2.862-3.914c-5.377-0.839-11.134,2.031-13.7,6.829c-2.567,4.798-1.759,11.18,1.923,15.187 c3.682,4.007,9.972,5.352,14.97,3.199C243.81,217.254,255.858,220.637,267.047,219.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M227.558,191.603c2.172,0.603,4.345,1.206,6.517,1.809"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M247.225,182.841c2.135-3.548,6.979-5.177,10.824-3.64"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M250.829,190.321c2.263-0.451,4.744,0.453,6.186,2.255"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M255.616,203.176c-0.037-1.127,0.884-2.204,2.004-2.342c1.119-0.138,2.274,0.683,2.512,1.785"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#936149"
    },
    d: "M308.932,206.07c0,0-2.57-7.934-5.4-16.612c-2.83-8.678-6.296-14.752-13.937-21.621 c-7.64-6.869-22.528-19.829-22.528-19.829c-0.632,0.025-1.085,0.688-1.111,1.319c-0.026,0.632,0.259,1.23,0.537,1.798 c1.095,2.235,2.19,4.471,3.285,6.706c-3.657-3.608-7.253-7.269-10.91-10.876c-0.824,0.056-1.653,0.994-1.636,1.821 c0.016,0.826,0.445,1.581,0.861,2.295c3.807,6.531,7.615,13.062,11.422,19.593c-5.656-5.99-11.657-12.195-17.313-18.185 c-0.813,0.515-1.328,1.288-1.184,2.24c0.144,0.952,0.645,1.806,1.136,2.633c3.657,6.163,7.315,12.326,10.972,18.488 c-3.961-3.805-8.003-7.581-11.964-11.387c-0.636,0.639-0.951,1.813-0.76,2.694c0.19,0.881,0.665,1.67,1.132,2.441 c3.153,5.204,6.306,10.408,9.458,15.611c0,0,2.727,9.614,4.662,19.383c1.935,9.769,2.391,14.081,8.28,27.523 s18.754,43.956,25.38,57.925s20.322,17.627,32.533,11.68c12.211-5.947,17.95-18.322,10.124-34.998 C334.145,250.038,308.932,206.07,308.932,206.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M269.529,220.294c-1.587-2.421-2.427-5.421-3.001-8.259c-1.799-8.899-1.119-18.887-5.686-26.733 c-3.385-5.814-6.77-11.629-10.155-17.444c-0.671-1.153-0.566-2.866,0.503-3.665c4.497,4.503,9.153,8.728,13.65,13.231"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M268.806,156.349c4.656,4.897,9.312,9.795,13.968,14.692"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M263.092,163.555c3.253,3.712,6.506,7.425,9.759,11.137"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M256.704,165.641c1.585,2.561,3.17,5.121,4.756,7.682"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#150D0D",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 129.706,
    y1: 423.799,
    x2: 366.544,
    y2: 423.799
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisappointment);
export default __webpack_public_path__ + "static/media/disappointment.a7e5ac56157a2a3c0649ca68fdb82ebb.svg";
export { ForwardRef as ReactComponent };